'use client';

var vi = {
	"Type country name or code": "Nhập tên hoặc mã quốc tế",
	"This field is required.": "Vui lòng nhập thông tin.",
	"The phone number format is invalid.": "Số điện thoại của bạn không hợp lệ.",
	"Accept 7 - 15 digits.": "Chấp nhận 7 - 15 chữ số.",
	"No result found": "Không có kết quả"
};

export { vi as default };
//# sourceMappingURL=vi.json.js.map
